import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import config from '@/config'
import { useDispatch } from '@/hooks/redux'
import { Label } from '@/components/text'
import Icon from '@/components/icon'
import { colors } from '@/styles'
import useClickOutside from '@/hooks/use-click-outside'

const isDev = config.BUILD_ENV === 'dev'

const SubMenuWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px 0px;
  background: ${colors.white};
  border: 1.5px solid ${colors.grey88};
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
`

const SubMenuItem = styled.button`
  background: none;
  border: none;
  display: flex;
  width: 100%;
  padding: 12px 12px;
  gap: 10px;
  align-items: center;
  cursor: pointer;
  color: ${props => (props.color ? props.color : colors.grey56)};
`

type SubMenuProps = {
  hideCompleted: boolean
  toggleCompleted: () => void
  setEnabled: (x: boolean) => void
  close: () => void
}

const SubMenu: React.FC<SubMenuProps> = ({ hideCompleted, toggleCompleted, close, setEnabled }) => {
  const { t } = useTranslation()
  const ref = useClickOutside(close)
  const dispatch = useDispatch()

  const handleHide = () => {
    toggleCompleted()
    close()
  }
  const handleSkipClick = () => {
    setEnabled(false)
  }
  const handleDevClear = () => {
    dispatch.toaster.reset()
  }
  return (
    <SubMenuWrapper ref={ref}>
      <SubMenuItem onClick={handleHide}>
        {!hideCompleted ? (
          <>
            <Icon id="toaster_hide_completed" width={14} height={14} />
            <Label fontSize="14px">
              {t('b.toaster.view.submenu.hidecompleted', 'Hide completed tasks')}
            </Label>
          </>
        ) : (
          <>
            <Icon id="toaster_view_all" width={14} height={14} />
            <Label fontSize="14px">{t('b.toaster.view.submenu.viewall', 'View all tasks')}</Label>
          </>
        )}
      </SubMenuItem>
      <SubMenuItem
        color={colors.red64}
        onClick={() => {
          handleSkipClick()
        }}
      >
        <Icon id="toaster_skip" width={14} height={14} />
        <Label fontSize="14px">{t('b.toaster.view.submenu.skip', 'Skip onboarding')}</Label>
      </SubMenuItem>
      {isDev && (
        <SubMenuItem color={colors.blue48} onClick={handleDevClear}>
          <Label fontSize="14px">DEV - Reset Toaster</Label>
        </SubMenuItem>
      )}
    </SubMenuWrapper>
  )
}

export default SubMenu
